import { useEffect, useState } from "react";

const sizes = {
	mobile: 768,
	tablet: 1024,
};

export const useIsMobile = () => {
	const checkForMobile = () => window.innerWidth < sizes.mobile;
	const checkForTablet = () => window.innerWidth >= sizes.mobile && window.innerWidth < sizes.tablet;

	const [isMobile, setIsMobile] = useState(checkForMobile());
	const [isTablet, setIsTablet] = useState(checkForTablet());

	useEffect(() => {
		const handlePageResized = () => {
			setIsMobile(checkForMobile());
			setIsTablet(checkForTablet());
		};

		if (typeof window !== "undefined") {
			window.addEventListener("resize", handlePageResized);
			window.addEventListener("orientationchange", handlePageResized);
			window.addEventListener("load", handlePageResized);
			window.addEventListener("reload", handlePageResized);
		}

		return () => {
			if (typeof window !== "undefined") {
				window.removeEventListener("resize", handlePageResized);
				window.removeEventListener("orientationchange", handlePageResized);
				window.removeEventListener("load", handlePageResized);
				window.removeEventListener("reload", handlePageResized);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		isMobile,
		isTablet
	};
};
